export const TICKETING_SYSTEM_PATH = '/ticketingSystem';
